module.exports = __webpack_public_path__ + "fonts/313f7dacf2076822059d2dca26dedfc6.535877f5.woff";